export default __webpack_public_path__ + "static/WebsitePreview-530c20c9473d4a7414ea7385116a50c6.png";